<template>
  <div>
    <el-card shadow="never" class="mb-20">
      <el-row
        v-loading="loading"
        :gutter="12"
        justify="space-between"
        type="flex"
      >
        <el-col :span="4"> 差异单号： {{ supply_feedback_dif.id }}</el-col>
        <el-col :span="18">
          处理状态：{{ supply_feedback_dif.verify_status_txt }}
        </el-col>
        <el-col :span="2">
          <el-button style="cursor: pointer" type="text" @click="fetchData"
            >刷新</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <el-card v-loading="loading" shadow="never" class="card-style">
      <el-col :span="24" class="col-style">
        <div class="bold-title">商家反馈差异</div>
      </el-col>
      <el-col :span="24" class="col-style">
        <div class="table-title">包裹信息</div>
        <el-table
          :key="'table1'"
          :data="[supply_feedback_dif]"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="package_type_txt"
            label="包裹类型"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="package_no" label="包裹号" align="center">
          </el-table-column>
          <el-table-column
            prop="spr_create_time"
            label="包裹生成时间"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="supply_id" label="商家ID" align="center">
          </el-table-column>
          <el-table-column prop="supply_name" label="商家" align="center">
          </el-table-column>
          <el-table-column
            prop="billing_type_txt"
            label="开单方式"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="market_name" label="市场" align="center">
          </el-table-column>
          <el-table-column prop="city_txt" label="城市" align="center">
          </el-table-column>
          <el-table-column prop="pg_name" label="代采组" align="center">
          </el-table-column>
          <el-table-column prop="pg_member_name" label="代采员" align="center">
          </el-table-column>
          <el-table-column prop="user_name" label="商家反馈人" align="center">
            <template #default="{ row }">
              <div>{{ row.user_name }}（爆版id：{{ row.user_id }}）</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_at"
            label="商家反馈时间"
            align="center"
          >
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24">
        <div class="table-title" @click="toggleFilter('difGoodsTogglle')">
          <div>
            差异商品信息
            <el-button
              type="text"
              :icon="
                toggle.difGoodsTogglle
                  ? 'el-icon-arrow-down'
                  : 'el-icon-arrow-up'
              "
            ></el-button>
          </div>
          <el-button type="success" @click="handleDifGoodsExport"
            >导出</el-button
          >
        </div>
        <el-collapse-transition>
          <div v-show="toggle.difGoodsTogglle" style="display: flex">
            <div style="width: 80%">
              <el-table
                :key="'table2'"
                :data="processedTableData"
                border
                style="width: 70%"
                max-height="400px"
                :span-method="arraySpanMethod"
                :header-cell-class-name="addColor"
                :cell-class-name="addColor"
              >
                <el-table-column
                  fixed="left"
                  prop="img"
                  label="商品图片"
                  align="center"
                  width="90"
                >
                  <template #default="{ row }">
                    <div
                      v-viewer
                      style="
                        width: 60px;
                        height: 60px;
                        overflow: hidden;
                        cursor: pointer;
                      "
                    >
                      <img
                        style="width: 100%; height: 100%"
                        :src="row.main_img"
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="goods_name"
                  label="商品名称"
                  align="center"
                  width="150"
                >
                </el-table-column>
                <el-table-column
                  prop="goods_no"
                  label="货号"
                  align="center"
                  width="120"
                >
                </el-table-column>
                <el-table-column
                  prop="goods_kh"
                  label="款号"
                  align="center"
                  width="120"
                >
                </el-table-column>
                <el-table-column
                  prop="sku"
                  label="SKU"
                  align="center"
                  width="100"
                >
                  <template #default="{ row }">
                    {{ row.sku }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="co_val"
                  label="颜色"
                  align="center"
                  width="100"
                >
                  <template #default="{ row }">
                    {{ row.co_val }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="si_val"
                  label="尺码"
                  align="center"
                  width="100"
                >
                  <template #default="{ row }">
                    {{ row.si_val }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="stock_num"
                  label="一手入库数（商家反馈时）"
                  align="center"
                  width="110"
                >
                  <template #default="{ row }">
                    <div>
                      {{ row.stock_num }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="current_num"
                  label="一手入库数（当前实时）"
                  align="center"
                  width="110"
                >
                  <template #default="{ row }">
                    {{ row.current_num }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="num"
                  label="商家配货数"
                  align="center"
                  width="100"
                >
                  <template #default="{ row }">
                    {{ row.num }}
                  </template>
                </el-table-column>
                <el-table-column prop="feedback_num" width="100" align="center">
                  <span slot="header">
                    <div>反馈时入库件数差异</div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="反馈时入库差异件数 = 商家反馈时的一手已入库件数 - 商家配货件数"
                      placement="top-start"
                    >
                      <i class="el-icon-question" />
                    </el-tooltip>
                  </span>
                  <template #default="{ row }">
                    <NumColorCell :num="row.feedback_num || ''" />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="in_feedback_num"
                  align="center"
                  fixed="right"
                >
                  <div slot="header">
                    <div>当前入库件数差异</div>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="当前入库差异件数 = 当前实时的一手已入库件数 - 商家配货件数"
                      placement="top-start"
                    >
                      <i class="el-icon-question" />
                    </el-tooltip>
                  </div>
                  <template #default="{ row }">
                    <NumColorCell :num="row.in_feedback_num || ''" />
                  </template>
                </el-table-column>
              </el-table>
              <el-table
                :key="'table3'"
                :data="amountTableData"
                border
                style="width: 70%"
                :show-header="false"
                :cell-class-name="addColor"
              >
                <el-table-column
                  prop="img"
                  label=""
                  align="center"
                  width="90"
                  fixed="left"
                >
                  合计
                </el-table-column>

                <el-table-column prop="" label="" align="center" width="150">
                </el-table-column>
                <el-table-column prop="" label="" align="center" width="120">
                </el-table-column>
                <el-table-column prop="" label="" align="center" width="120">
                </el-table-column>
                <el-table-column prop="" label="" align="center" width="100">
                </el-table-column>
                <el-table-column prop="" label="" align="center" width="100">
                </el-table-column>
                <el-table-column prop="" label="" align="center" width="100">
                </el-table-column>

                <el-table-column prop="stock_num" align="center" width="110">
                  <template #default="{ row }">
                    {{ row.stock_num }}
                  </template>
                </el-table-column>
                <el-table-column prop="current_num" align="center" width="110">
                  <template #default="{ row }">
                    {{ row.current_num }}
                  </template>
                </el-table-column>
                <el-table-column prop="num" align="center" width="100">
                  <template #default="{ row }">
                    {{ row.num }}
                  </template>
                </el-table-column>
                <el-table-column prop="" width="100" align="center">
                  <template #default="{ row }">
                    <NumColorCell :num="row.feedback_num || ''" />
                  </template>
                </el-table-column>
                <el-table-column
                  prop="in_feedback_num"
                  align="center"
                  fixed="right"
                >
                  <template #default="{ row }">
                    <NumColorCell :num="row.current_feedback_num || ''" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div style="width: 20%">
              <el-table
                :key="'table4'"
                border
                width="100%"
                :data="[supply_feedback_dif]"
              >
                <el-table-column
                  prop="imgs"
                  label="商家提交的配货凭证"
                  align="center"
                  height="100"
                >
                  <template #default="{ row }">
                    <div v-viewer style="width: 100%" class="voucher-box">
                      <img
                        v-for="(item, index) in viewImg"
                        :key="item + index"
                        :src="item"
                        class="viewer-img"
                      />
                    </div>
                    <div class="voucher--video-box">
                      <video
                        v-for="(item, index) in viewVideo"
                        :key="item + index"
                        width="250"
                        :src="item"
                        controls
                        class="viewer-video"
                      />
                    </div>
                    <div 
                      v-if="supply_feedback_dif.description_of_differences" 
                      style="text-align: left;font-size: 14px;padding-top: 10px;"
                    >
                      <div style="color: #BCBCBC;">差异反馈补充说明：</div>
                      <div style="color: black;">{{ supply_feedback_dif.description_of_differences }}</div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-card>
    <el-card shadow="never" class="card-style">
      <el-col :span="24" class="col-style">
        <div class="table-title" @click="toggleFilter('supplyPackageTogglle')">
          <div style="display: flex">
            商家当天包裹入库信息
            <el-button
              type="text"
              :icon="
                toggle.supplyPackageTogglle
                  ? 'el-icon-arrow-down'
                  : 'el-icon-arrow-up'
              "
            ></el-button>
            <div
              v-if="
                supply_feedback_dif.package_type ===
                constantMap.package_type.MASS_GOODS
              "
              style="margin-left: 30px"
            >
              商家当天开单：{{ supply_feedback_dif.day_total_num }} 件
            </div>
          </div>
        </div>
      </el-col>
      <el-collapse-transition>
        <el-col
          v-show="toggle.supplyPackageTogglle"
          :span="24"
          class="col-style"
        >
          <el-tabs v-model="activeTab">
            <el-tab-pane label="按包裹" name="package">
              <InventoryByPackage
                v-if="!loading"
                :form-props="formProps"
              ></InventoryByPackage>
            </el-tab-pane>
            <el-tab-pane label="按入库商品" name="goods">
              <InventoryByGoods
                v-if="!loading"
                :form-props="formProps"
              ></InventoryByGoods>
            </el-tab-pane>
            <el-tab-pane
              label="商家反馈缺漏商品（一手无入库）"
              name="lackGoods"
            >
              <InventoryByLackGoods
                v-if="!loading"
                :form-props="formProps"
              ></InventoryByLackGoods
            ></el-tab-pane>
          </el-tabs>
        </el-col>
      </el-collapse-transition>
    </el-card>
    <el-card shadow="never" class="card-style">
      <el-col :span="24" class="col-style">
        <div class="table-title" @click="toggleFilter('WarehouseVerifyToggle')">
          <div>
            仓库核实
            <el-button
              type="text"
              :icon="
                toggle.WarehouseVerifyToggle
                  ? 'el-icon-arrow-down'
                  : 'el-icon-arrow-up'
              "
            ></el-button>
          </div>
        </div>
      </el-col>
      <el-collapse-transition>
        <el-form
          ref="warehouseVerifyForm"
          :model="warehouse_verify_data"
          :rules="warehouseVerifyFormRules"
        >
          <el-col
            v-show="toggle.WarehouseVerifyToggle"
            :span="24"
            class="col-style ml-20 pr-20"
          >
            <div class="mb-20">
              <div>仓库核实说明（回复商家，商家可见）</div>
              <el-form-item prop="warehouse_verify_explain">
                <ys-input
                  v-model="warehouse_verify_data.warehouse_verify_explain"
                  placeholder="请填写核实说明，商家可见"
                  type="textarea"
                  show-word-limit
                  rows="3"
                  :disabled="
                    supply_feedback_dif.verify_status !==
                    constantMap.verify_status.TO_BE_VERIFIED
                  "
                ></ys-input>
              </el-form-item>
            </div>
            <div
              v-if="
                supply_feedback_dif.verify_status ===
                constantMap.verify_status.TO_BE_VERIFIED
              "
              class="mb-20"
            >
              <div>上传仓库点货凭证（商家可见）</div>
              <el-form-item prop="warehouse_imgs">
                <div>
                  <el-col :span="24" :style="'width:100%;'">
                    <el-upload
                      class="upload-demo"
                      :show-file-list="false"
                      :action="action"
                      multiple
                      accept="image/*"
                      :on-success="uploadSuccessImg"
                      :on-remove="handleRemoveImg"
                      :on-exceed="handleExceedImg"
                      :file-list="imgFileList"
                      :limit="constantMap.limit"
                      :disabled="videoFlag"
                      :on-change="handleChangeImg"
                      :on-error="handleErrorImg"
                      with-credentials
                    >
                      <el-button
                        size="small"
                        style="margin: 10px 3px"
                        type="primary"
                      >
                        上传图片
                      </el-button>
                    </el-upload>
                    <template v-if="verifyVoucherImg.length > 0">
                      <div v-viewer class="viewer-box" style="width: 100%">
                        <div
                          v-for="(item, index) in verifyVoucherImg"
                          :key="item + index"
                          style="position: relative"
                        >
                          <img
                            :src="origin + '/' + item.url"
                            class="viewer-img"
                          />
                          <i
                            class="el-icon-circle-close delete-icon"
                            @click="handleDelImages(item, index)"
                          />
                        </div>
                      </div>
                    </template>
                  </el-col>
                  <el-col>
                    <span style="color: #999">
                      单张图片不要超过10M，最多可上传5张图片
                    </span>
                  </el-col>
                </div>

                <div>
                  <el-col :span="24" :style="'width:100%;'">
                    <el-upload
                      :style="'width:100px;float:left;height:50px;'"
                      class="upload-demo"
                      :show-file-list="false"
                      :action="uploadActionUrl"
                      :data="uploadData"
                      multiple
                      :limit="constantMap.limit"
                      style="display: inline-block; margin-right: 10px"
                      accept="video/*"
                      :on-success="uploadSuccessVideo"
                      :before-upload="beforeVideoUpload"
                      :on-progress="uploadVideoProcess"
                      :on-exceed="handleVideoExceed"
                      :file-list="videoFileList"
                    >
                      <el-button
                        size="small"
                        style="margin: 10px 3px"
                        type="primary"
                      >
                        上传视频
                      </el-button>
                    </el-upload>
                    <template v-if="verifyVoucherVideo.length > 0">
                      <div style="width: 100%; display: flex; overflow: auto">
                        <div
                          v-for="(item, index) in verifyVoucherVideo"
                          :key="item + index"
                          style="position: relative"
                        >
                          <video
                            :src="origin + '/' + item.url"
                            width="250"
                            controls
                            class="viewer-video"
                          />
                          <i
                            class="el-icon-circle-close video-delete-icon"
                            @click="handleDelVideos(item, index)"
                          />
                        </div>
                      </div>
                    </template>
                    <el-progress
                      v-if="videoFlag == true"
                      type="circle"
                      :percentage="videoUploadPercent"
                      style="margin-top: 30px"
                    />
                  </el-col>
                  <el-col>
                    <span style="color: #999">
                      单个视频不要超过100M，最多可上传5个视频
                    </span>
                  </el-col>
                </div>
              </el-form-item>
            </div>
            <div
              v-if="
                ![constantMap.verify_status.TO_BE_VERIFIED].includes(
                  supply_feedback_dif.verify_status
                )
              "
              class="mb-20"
            >
              <div>仓库点货凭证（商家可见）</div>
              <div
                v-if="verifyVoucherImgSupply.length > 0"
                v-viewer
                class="viewer-box media-box"
              >
                <img
                  v-for="(item, index) in verifyVoucherImgSupply"
                  :key="index"
                  :src="item"
                  class="viewer-img"
                />
              </div>
              <div
                v-if="verifyVoucherVideoSupply.length > 0"
                class="viewer-box media-box"
              >
                <video
                  v-for="(item, index) in verifyVoucherVideoSupply"
                  :key="item + index"
                  controls
                  class="viewer-video-small"
                  width="150"
                  :src="item"
                />
              </div>
            </div>
            <div class="mb-20">
              <div>仓库核实说明（仅内部可见）</div>
              <el-form-item prop="warehouse_verify_explain_private">
                <ys-input
                  v-model="
                    warehouse_verify_data.warehouse_verify_explain_private
                  "
                  placeholder="请填写核实说明，仅内部可见"
                  type="textarea"
                  show-word-limit
                  rows="3"
                  :disabled="
                    supply_feedback_dif.verify_status !==
                    constantMap.verify_status.TO_BE_VERIFIED
                  "
                ></ys-input>
              </el-form-item>
            </div>
            <div
              v-if="
                ![constantMap.verify_status.TO_BE_VERIFIED].includes(
                  supply_feedback_dif.verify_status
                )
              "
              class="mb-20"
            >
              <div class="cell-box">
                <div>
                  仓库核实人： {{ supply_feedback_dif.warehouse_admin_name }}
                </div>
                <div>
                  仓库核实时间：
                  {{ supply_feedback_dif.warehouse_verify_time_txt }}
                </div>
              </div>
            </div>
            <div
              v-if="
                supply_feedback_dif.verify_status ===
                constantMap.verify_status.TO_BE_VERIFIED
              "
              class="center-flex-box"
            >
              <el-button type="primary" @click="handleVerfiy"
                >核实处理</el-button
              >
            </div>
            <div />
          </el-col>
        </el-form>
      </el-collapse-transition>
    </el-card>
    <el-card
      v-if="
        [
          constantMap.verify_status.DEALED,
          constantMap.verify_status.TO_BE_DEALED,
        ].includes(supply_feedback_dif.verify_status)
      "
      shadow="never"
      class="card-style"
    >
      <el-col :span="24" class="col-style">
        <div class="table-title" @click="toggleFilter('supplyAppealToggle')">
          <div>
            商家申诉
            <el-button
              type="text"
              :icon="
                toggle.supplyAppealToggle
                  ? 'el-icon-arrow-down'
                  : 'el-icon-arrow-up'
              "
            ></el-button>
          </div>
        </div>
      </el-col>
      <el-collapse-transition>
        <el-col
          v-show="toggle.supplyAppealToggle"
          :span="24"
          class="col-style ml-20 pr-20"
        >
          <div class="mb-20">
            <div>商家申诉说明</div>
            <ys-input
              v-model="supply_feedback_dif.supply_reason_application"
              type="textarea"
              show-word-limit
              rows="3"
              disabled
            ></ys-input>
          </div>
          <div class="mb-20">
            <div>商家补充凭证</div>
            <div v-viewer class="viewer-box media-box">
              <img
                v-for="(item, index) in supplyAppealImg"
                :key="index"
                :src="item"
                class="viewer-img"
              />
            </div>
            <div
              v-if="supplyAppealVideo.length > 0"
              class="viewer-box media-box"
            >
              <video
                v-for="(item, index) in supplyAppealVideo"
                :key="item + index"
                controls
                class="viewer-video-small"
                width="150"
                :src="item"
              />
            </div>
          </div>
          <div class="mb-20">
            <div class="cell-box">
              <div>
                申诉人： {{ supply_feedback_dif.supply_reason }}（爆版id：{{
                  supply_feedback_dif.supply_reason_id
                }}）
              </div>
              <div>
                申诉时间： {{ supply_feedback_dif.supply_reason_time_txt }}
              </div>
            </div>
          </div>
          <div />
        </el-col>
      </el-collapse-transition>
    </el-card>
    <el-card
      v-if="
        [
          constantMap.verify_status.DEALED,
          constantMap.verify_status.TO_BE_DEALED,
        ].includes(supply_feedback_dif.verify_status)
      "
      shadow="never"
      class="card-style"
    >
      <el-col :span="24" class="col-style">
        <div class="table-title" @click="toggleFilter('ysAppealToggle')">
          <div>
            一手申诉处理
            <el-button
              type="text"
              :icon="
                toggle.ysAppealToggle
                  ? 'el-icon-arrow-down'
                  : 'el-icon-arrow-up'
              "
            ></el-button>
          </div>
        </div>
      </el-col>
      <el-collapse-transition>
        <el-form
          ref="complainForm"
          :model="complain_handling_data"
          :rules="complainFormRules"
        >
          <el-col
            v-show="toggle.ysAppealToggle"
            :span="24"
            class="col-style ml-20 pr-20"
          >
            <div class="mb-20" style="display: flex">
              <div style="height: 40px; line-height: 40px">责任承担方：</div>
              <el-form-item prop="responsible_party_type">
                <el-select
                  v-model="complain_handling_data.responsible_party_type"
                  placeholder="请选择"
                  :disabled="
                    [constantMap.verify_status.DEALED].includes(
                      supply_feedback_dif.verify_status
                    )
                  "
                >
                  <el-option
                    v-for="item in constantMap.responsible_party_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="mb-20">
              <div>申诉处理说明（回复商家，商家可见）</div>
              <el-form-item prop="complain_handling_explain">
                <ys-input
                  v-model="complain_handling_data.complain_handling_explain"
                  placeholder="请填写处理说明"
                  type="textarea"
                  show-word-limit
                  rows="3"
                  :disabled="
                    [constantMap.verify_status.DEALED].includes(
                      supply_feedback_dif.verify_status
                    )
                  "
                ></ys-input>
              </el-form-item>
            </div>
            <div class="mb-20">
              <div>申诉处理说明（仅内部可见）</div>
              <el-form-item prop="complain_handling_explain_private">
                <ys-input
                  v-model="
                    complain_handling_data.complain_handling_explain_private
                  "
                  placeholder="请填写处理说明"
                  type="textarea"
                  show-word-limit
                  rows="3"
                  :disabled="
                    [constantMap.verify_status.DEALED].includes(
                      supply_feedback_dif.verify_status
                    )
                  "
                ></ys-input>
              </el-form-item>
            </div>
            <div
              v-if="
                [constantMap.verify_status.DEALED].includes(
                  supply_feedback_dif.verify_status
                )
              "
              class="mb-20"
            >
              <div class="cell-box">
                <div>
                  申诉处理人：
                  {{ supply_feedback_dif.complain_handling_admin_name }}
                </div>
                <div>
                  申诉处理时间：
                  {{ supply_feedback_dif.complain_handling_time_txt }}
                </div>
              </div>
            </div>
            <div
              v-if="
                [constantMap.verify_status.TO_BE_DEALED].includes(
                  supply_feedback_dif.verify_status
                )
              "
              class="center-flex-box"
            >
              <el-button type="primary" @click="handleComplain"
                >申诉处理</el-button
              >
            </div>
            <div />
          </el-col>
        </el-form>
      </el-collapse-transition>
    </el-card>
  </div>
</template>

<script>
import md5 from "js-md5";
import apiBaseURL from "@/utils/baseUrl.js";
import {
  postDetail,
  postVerificationProcessing,
  postComplaintHanding,
  postGetList,
} from "@/openapi/erp/supplyPackageCheckRecord.js";
import NumColorCell from "@//pages/receiveGoods/StockVarianceProcess/components/NumColorCell.vue";
import InventoryByPackage from "@/pages/receiveGoods/StockVarianceProcess/components/InventoryByPackage.vue";
import InventoryByLackGoods from "@/pages/receiveGoods/StockVarianceProcess/components/InventoryByLackGoods.vue";
import InventoryByGoods from "@/pages/receiveGoods/StockVarianceProcess/components/InventoryByGoods.vue";

const parser = new DOMParser();
const constantMap = {
  limit: 5,
  package_type: {
    MASS_GOODS: "1", // 大货
    PRE_STOCK: "2", // 前置仓
  },
  // 核实状态:{1:仓库待核实,2:仓库已核实,3:申诉待处理,4:申诉已处理}
  verify_status: {
    TO_BE_VERIFIED: "1",
    VERIFIED: "2",
    TO_BE_DEALED: "3",
    DEALED: "4",
  },
  responsible_party_options: [
    {
      value: "1",
      label: "一手公司",
    },
    {
      value: "2",
      label: "一手仓库",
    },
    {
      value: "3",
      label: "商家",
    },
    {
      value: "4",
      label: "无责任方",
    },
  ],
};
const VIDEO_MAX_SIZE = 500;
export default {
  components: {
    NumColorCell,
    InventoryByPackage,
    InventoryByLackGoods,
    InventoryByGoods,
  },
  data() {
    return {
      VIDEO_MAX_SIZE,
      // 仓库核实的图片和视频，提交前处理到warehouse_imgs提交给接口
      verifyVoucherImg: [],
      verifyVoucherVideo: [],
      uploadedVideos: [],
      constantMap,
      supply_feedback_dif: {
        goods_nos: [],
        feedback_statics: {},
        imgs: [],
      },
      loading: false,
      toggle: {
        difGoodsTogglle: true,
        supplyPackageTogglle: true,
        WarehouseVerifyToggle: true,
        supplyAppealToggle: true,
        ysAppealToggle: true,
      },
      activeTab: "package",
      warehouse_verify_data: {
        package_record_id: "",
        warehouse_verify_explain: "", // 仓库核实说明（回复商家，商家可见）
        warehouse_verify_explain_private: "", // 仓库核实说明（仅内部可见）
        warehouse_imgs: [],
      },
      complain_handling_data: {
        package_record_id: "", // 包裹ID
        responsible_party_type: "", // 责任承担方
        complain_handling_explain: "", // 申诉处理说明(恢复商家，商家可见)
        complain_handling_explain_private: "", // 申诉处理说明(仅内部可见)
      },
      warehouseVerifyFormRules: {
        warehouse_verify_explain: [
          {
            required: true,
            message: "仓库核实说明（回复商家，商家可见）",
            trigger: "blur",
          },
        ],
        warehouse_verify_explain_private: [
          {
            required: true,
            message: "仓库核实说明（仅内部可见）",
            trigger: "blur",
          },
        ],
      },
      complainFormRules: {
        responsible_party_type: [
          { required: true, message: "请选择责任承担方", trigger: "change" },
        ],
        complain_handling_explain: [
          {
            required: true,
            message: "请填写申诉处理说明（回复商家，商家可见）",
            trigger: "blur",
          },
        ],
        complain_handling_explain_private: [
          {
            required: true,
            message: "请填写申诉处理说明（仅内部可见）",
            trigger: "blur",
          },
        ],
      },
      uploadData: {
        key: "",
        "content-type": "",
        policy: "",
        AccessKeyId: "",
        signature: "",
        success_action_status: "",
        domain: "",
        bucket: "",
      },
      uploadPath: "",
      uploadActionUrl: "",
      tokenUrl: "/open/Merchants/getObsUploadData",
      uploadHeaders: { "Content-Type": "multipart/form-data" },
      videoFlag: false,
      videoUploadPercent: 0,
      dialogVisible: false,
      dialogImageUrl: [],
      imgFileList: [], // 上传的图片数组
      videoFileList: [], // 上传的视频数组
      origin: "https://img4.yishouapp.com",
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
    };
  },
  computed: {
    // 仓库点货凭证（商家可见)
    verifyVoucherImgSupply() {
      return this.filterMedia(
        this.supply_feedback_dif.warehouse_imgs,
        "img",
        "url"
      );
    },
    verifyVoucherVideoSupply() {
      return this.filterMedia(
        this.supply_feedback_dif.warehouse_imgs,
        "video",
        "video_url"
      );
    },
    // 商家申诉，商家补充凭证
    supplyAppealImg() {
      return this.filterMedia(
        this.supply_feedback_dif.supply_reason_imgs,
        "img",
        "url"
      );
    },
    supplyAppealVideo() {
      return this.filterMedia(
        this.supply_feedback_dif.supply_reason_imgs,
        "video",
        "video_url"
      );
    },
    viewImg() {
      return this.filterMedia(this.supply_feedback_dif.imgs, "img", "url");
    },
    viewVideo() {
      return this.filterMedia(
        this.supply_feedback_dif.imgs,
        "video",
        "video_url"
      );
    },
    processedTableData() {
      const result = [];
      this.supply_feedback_dif.goods_nos.forEach((goods) => {
        goods.skus.forEach((sku) => {
          result.push({
            ...goods,
            ...sku,
            sku: sku.sku,
            co_val: sku.co_val,
            si_val: sku.si_val,
          });
        });
      });
      return result;
    },
    formProps() {
      return {
        supply_id: this.supply_feedback_dif.supply_id,
        package_time: this.supply_feedback_dif.spr_create_time,
        package_type: this.supply_feedback_dif.package_type,
        supply_name: this.supply_feedback_dif.supply_name,
        current_package_no: this.supply_feedback_dif.package_no,
      };
    },
    amountTableData() {
      return [this.supply_feedback_dif.feedback_statics] || [];
    },
    voucherTableData() {
      return this.supply_feedback_dif?.imgs || [];
    },
    sumsData() {
      const { feedback_statics: feedbackStatics } =
        this.supply_feedback_dif.feedback_statics;
      const {
        feedback_num: feedbackNum = "",
        num = "",
        feedback_num_abs: feedbackNumAbs = "",
        current_feedback_num: currentFeedbackNum = "",
      } = feedbackStatics;
      let sums = [];
      sums = [
        "总计算",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        feedbackNum,
        num,
        feedbackNumAbs,
        currentFeedbackNum,
      ];
      return sums; // 返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
  },
  created() {
    this.fetchData();
    this.getToken();
  },
  methods: {
    addColor({ columnIndex }) {
      if (columnIndex === 7 || columnIndex === 10) {
        return "grey-highlight";
      }
      return "";
    },
    // 通用过滤方法
    filterMedia(items, type, urlKey) {
      if (!Array.isArray(items)) {
        return [];
      }
      return items
        .filter((item) => item.type === type && item[urlKey])
        .map((item) => item[urlKey]);
    },
    async handleDifGoodsExport(e) {
      e.stopPropagation();
      try {
        const params = {
          check_record_id: this.supply_feedback_dif.id,
          export: 2, // 导出差异明细
        };
        const res = await postGetList(params);
        if (res.file) {
          window.open(apiBaseURL + res.file);
        }
      } catch (error) {
        console.log(error);
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (
        columnIndex === 0 ||
        columnIndex === 1 ||
        columnIndex === 2 ||
        columnIndex === 3
      ) {
        const currentGoodsNo = row.goods_no;
        const prevGoodsNo =
          rowIndex > 0 ? this.processedTableData[rowIndex - 1].goods_no : null;

        if (currentGoodsNo !== prevGoodsNo) {
          let rowspan = 1;
          for (
            let i = rowIndex + 1;
            i < this.processedTableData.length &&
            this.processedTableData[i].goods_no === currentGoodsNo;
            i++
          ) {
            rowspan += 1;
          }
          return {
            rowspan,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
      return {
        rowspan: 1,
        colspan: 1,
      };
    },
    toggleFilter(params) {
      this.toggle[params] = !this.toggle[params];
    },
    async fetchData() {
      const params = { check_record_id: this.$route.params.id };
      try {
        const res = await postDetail(params);
        this.supply_feedback_dif = res;
        const {
          package_record_id: packageRecordId,
          responsible_party_type: responsiblePartyType,
          complain_handling_explain: complainHandlingExplain,
          complain_handling_explain_private: complainHandlingExplainPrivate,
          warehouse_verify_explain: warehouseVerifyExplain,
          warehouse_verify_explain_private: warehouseVerifyExplainPrivate,
        } = res;
        this.complain_handling_data = {
          ...this.complain_handling_data,
          package_record_id: packageRecordId,
          responsible_party_type: responsiblePartyType,
          complain_handling_explain: complainHandlingExplain,
          complain_handling_explain_private: complainHandlingExplainPrivate,
        };
        this.warehouse_verify_data = {
          ...this.warehouse_verify_data,
          package_record_id: packageRecordId,
          warehouse_verify_explain: warehouseVerifyExplain,
          warehouse_verify_explain_private: warehouseVerifyExplainPrivate,
        };
      } catch (err) {
        // 处理错误的逻辑
        console.error("fetchData error: ", err);
      } finally {
        this.loading = false;
      }
    },
    handleChangeImg(file, fileList) {
      this.imgFileList = fileList;
    },
    handleErrorImg(err, file, fileList) {
      this.$message.warning("图片上传失败，请重新上传");
      this.imgFileList = fileList.filter((item) => item.status !== "fail");
    },
    handleRemoveImg(file) {
      const index = this.imgFileList.findIndex(
        (item) => item.name === file.name
      );
      this.imgFileList.splice(index, 1);
    },
    uploadSuccessImg(response, file, fileList) {
      this.imgFileList = fileList;
      this.verifyVoucherImg = this.imgFileList.map((item) => {
        if (item.response) {
          return {
            type: "img",
            url: item.response.data.files[0],
          };
        }
        return {
          type: "img",
          url: "",
        };
      });
    },
    uploadSuccessVideo(res, file, fileList) {
      this.videoFlag = false;
      this.videoFileList = fileList;
      this.verifyVoucherVideo = this.videoFileList.map((item) => {
        if (item.response) {
          const xmlDoc = parser.parseFromString(item.response, "text/xml");
          item.name = xmlDoc.querySelector("Key").innerHTML;
          item.url = `${item.name}`;
        }
        return { url: item.url, type: "video" };
      });
    },
    handleExceedImg() {
      this.$message.warning("最多只能上传5张");
    },
    handleVideoExceed() {
      this.$message.warning("最多只能上传5个视频");
    },
    beforeVideoUpload(file) {
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > VIDEO_MAX_SIZE) {
        this.$message.error(
          `视频太大了,请缩小到${VIDEO_MAX_SIZE}MB以内再上传,当前图片大小:${size}MB`
        );
        return false;
      }
      // 赋值上传文件
      this.uploadData["content-type"] = file.type;
      const time = new Date();
      const date = `${time.getFullYear()}${
        time.getMonth() + 1 < 9
          ? `0${time.getMonth().toString()}`
          : time.getMonth()
      }${time.getDate()}${time.getTime()}`;
      const year = `${time.getFullYear()}`;
      const month = `${
        time.getMonth() + 1 < 9
          ? `0${time.getMonth().toString()}`
          : time.getMonth()
      }`;
      const { name } = file;
      const prev = md5(date + name.split(".")[0]);
      const next = name.split(".")[name.split(".").length - 1];
      this.uploadData.key = `${
        this.uploadPath + year
      }/${month}/${prev}.${next}`;
      this.uploadData["content-type"] = file.type;
    },
    uploadVideoProcess(event, file) {
      this.videoFlag = true;
      this.videoUploadPercent = +file.percentage.toFixed(0);
    },
    async getToken() {
      try {
        const res = await this.$http.get(this.tokenUrl);
        if (res.data.code === 200) {
          const r = res.data.data;
          this.uploadData.AccessKeyId = r.uptoken.access_key_id;
          this.uploadData.domain = r.uptoken.domain;
          this.uploadData.policy = r.uptoken.policy;
          this.uploadData.signature = r.uptoken.signature;
          this.uploadData.success_action_status =
            r.uptoken.success_action_status;
          this.uploadData.bucket = r.bucket_name;
          const endPoint = r.endpoint;
          this.uploadActionUrl = `https://${this.uploadData.bucket}.${endPoint}/`;
          this.uploadPath = r.path;
        }
      } catch (err) {
        console.error("getToken error: ", err);
        // 这里可以添加错误处理逻辑，例如显示错误信息
      }
    },
    handleDelVideos(item, index) {
      if (this.verifyVoucherVideo.indexOf(item) >= 0) {
        this.verifyVoucherVideo.splice(index, 1);
        this.videoFileList.splice(index, 1);
      }
    },
    handleDelImages(item, index) {
      if (this.verifyVoucherImg.indexOf(item) >= 0) {
        this.verifyVoucherImg.splice(index, 1);
        this.imgFileList.splice(index, 1);
      }
    },
    handleVerfiy() {
      const warehouseVerifyData = {
        ...this.warehouse_verify_data,
        warehouse_imgs: [...this.verifyVoucherImg, ...this.verifyVoucherVideo],
      };
      this.$set(this, "warehouse_verify_data", warehouseVerifyData);
      if (this.warehouse_verify_data.warehouse_imgs.length === 0) {
        this.$message({
          type: "warning",
          message: "请上传仓库点货凭证",
        });
        return;
      }
      this.$refs.warehouseVerifyForm.validate((valid) => {
        if (valid) {
          this.$confirm("请确定是否核实处理", "确认", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
            .then(() => {
              const params = {
                ...this.warehouse_verify_data,
              };
              console.log("warehouse_verify_data params: ", params);
              postVerificationProcessing(params)
                .then((res) => {
                  this.fetchData();
                  this.$message({
                    type: "success",
                    message: "已核实",
                  });
                  console.log("postVerificationProcessing res: ", res);
                })
                .catch((err) => {
                  console.error(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleComplain() {
      this.$refs.complainForm.validate((valid) => {
        if (valid) {
          this.$confirm("请确定是否申诉处理", "确认", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          })
            .then(() => {
              // 请求接口
              const params = this.complain_handling_data;
              postComplaintHanding(params)
                .then(() => {
                  this.fetchData();
                  this.warehouse_verify_data =
                    this.$options.data().warehouse_verify_data;
                })
                .catch((err) => {
                  console.error(err);
                });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>
.card-style {
  margin-bottom: 20px;
  padding-bottom: 20px;
}

.col-style {
  margin-bottom: 20px;
}

.bold-title {
  font-weight: 500;
}

.table-title {
  height: 40px;
  line-height: 40px;
  display: flex;
  justify-content: space-between;
  background: #f3f3f3;
  cursor: pointer;
}

.ml-20 {
  margin-left: 20px;
}

.pr-20 {
  padding-right: 20px;
}

.cell-box {
  width: 600px;
  display: flex;
  justify-content: space-between;
}

.mb-20 {
  margin-bottom: 20px;
}

.center-flex-box {
  display: flex;
  justify-content: center;
  align-items: center;
}

.viewer-box {
  display: flex;
}

.voucher-box {
  display: flex;
  overflow: auto;
}

.viewer-img {
  max-height: 100px;
  max-width: 100px;
  cursor: pointer;
  margin-right: 10px;
}

.voucher--video-box {
  display: flex;
  max-height: 200px;
  overflow: auto;
  flex-direction: column;
}

.viewer-video {
  height: 150px;
  margin: 10px 10px 0 0;
  cursor: pointer;
  object-fit: cover;
}

.viewer-video-small {
  height: 150px;
  margin: 10px 10px 0 0;
  cursor: pointer;
  object-fit: cover;
}

.delete-icon {
  cursor: pointer;
  position: absolute;
  top: -15px;
  right: -5px;
  font-size: 20px;
  color: red;
}

.video-delete-icon {
  cursor: pointer;
  position: absolute;
  top: -1px;
  right: 5px;
  font-size: 20px;
  color: red;
}

.media-box {
  width: 100%;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/receiveGoods/StockVarianceProcess/StockVarianceProcessDetail.vue